import { render, staticRenderFns } from "./total-amount.vue?vue&type=template&id=b36b0432&scoped=true"
import script from "./total-amount.vue?vue&type=script&lang=js"
export * from "./total-amount.vue?vue&type=script&lang=js"
import style0 from "./total-amount.vue?vue&type=style&index=0&id=b36b0432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36b0432",
  null
  
)

export default component.exports